// Material
import { styled } from '@mui/material/styles'
// component
import { List } from '@mui/material'
// Common
import { ProfileActionItem } from '$common/profile-action-item'
// Icons
// assets [icons]
// TODO: postfix all with Icon keyword
import {
  ContactIcon,
  BookmarkIcon,
  SettingsOutlinedIcon,
  SupportIcon,
  LogOutIcon,
  AddUserIcon,
  CallOutlinedIcon,
} from '$common/icons'
// Localization
import { t } from '$i18n'
import {
  openContacts,
  openContactUs,
  openInviteFriends,
  openSettings,
} from '$logic/router'
import { getPrivateSpace } from '$logic/private-space'
import { showLogoutModal } from '$comp/modals/confirmation-dialog'
import { openRoom } from '$logic/opened-room'
import { getPvByUserId } from '$logic/pv'
import { useCanInvite } from '$logic/invite/react-hook'
import { SUPPORT_ACCOUNT_ID } from '$func/environmentInfo'

const StyledList = styled(List)(({ theme }) => ({
  padding: 0,
  margin: '5px 0',
  backgroundColor: theme.palette.white,
  borderRadius: 15,
  filter: 'drop-shadow(0px 0px 5px rgba(0, 0, 0, 0.1))',
}))

export function MyAccountActions() {
  // const userBalance = 1200

  // const onFinanceClick = nothing
  const onSavedMessageClick = () => {
    openRoom(getPrivateSpace()?.roomId)
    analite('PROFILE_SAVED_CLICK')
  }
  const onSupportClick = async () => {
    const pv = await getPvByUserId(SUPPORT_ACCOUNT_ID)
    if (pv?.roomId) openRoom(pv?.roomId)
    analite('PROFILE_SUPPORT_CLICK')
  }
  const canInvite = useCanInvite()

  const onContactsClick = () => {
    analite('PROFIE_CONTACTS_CLICK')
    openContacts()
  }
  const onPrivacyClick = () => {
    analite('PROFILE_PRIVACY_CLICK')
    //   openPrivacyPolicy
  }

  const onInviteClick = () => {
    analite('PROFILE_INVITE_CLICK')
    openInviteFriends()
  }

  return (
    <>
      <StyledList>
        <ProfileActionItem Icon={<ContactIcon />} onClick={onContactsClick}>
          {t('myAccount.contact')}
        </ProfileActionItem>

        {/* <ProfileActionItem */}
        {/*  Icon={<FinanceIcon />} */}
        {/*  onClick={onFinanceClick} */}
        {/*  disabled* /}
        {/* > */}
        {/*  <> */}
        {/*    {t('myAccount.balance')} */}
        {/*    <Typography component="span" color="gray"> */}
        {/*      {' '} */}
        {/*      ({t('myAccount.credit')} */}
        {/*      <Typography component="span" color="green"> */}
        {/*        {' '} */}
        {/*        {userBalance} */}
        {/*      </Typography> */}
        {/*      ) */}
        {/*    </Typography> */}
        {/*  </> */}
        {/* </ProfileActionItem> */}

        <ProfileActionItem
          Icon={<BookmarkIcon />}
          onClick={onSavedMessageClick}
        >
          {t('myAccount.savedMessage')}
        </ProfileActionItem>

        <ProfileActionItem
          Icon={<SettingsOutlinedIcon />}
          onClick={openSettings}
        >
          {t('common.settings')}
        </ProfileActionItem>
      </StyledList>

      <StyledList>
        <ProfileActionItem Icon={<SupportIcon />} onClick={onSupportClick}>
          {t('myAccount.support')}
        </ProfileActionItem>

        <ProfileActionItem Icon={<CallOutlinedIcon />} onClick={openContactUs}>
          {t('myAccount.contactUs')}
        </ProfileActionItem>

        {canInvite && (
          <ProfileActionItem Icon={<AddUserIcon />} onClick={onInviteClick}>
            {t('myAccount.inviteFriends')}
          </ProfileActionItem>
        )}

        {/* <ProfileActionItem */}
        {/*  Icon={<RulesIcon />} */}
        {/*  onClick={onPrivacyPolicyClick} */}
        {/*  disabled */}
        {/* > */}
        {/*  {t('common.termsAndConditions')} */}
        {/* </ProfileActionItem> */}

        <ProfileActionItem Icon={<LogOutIcon />} onClick={showLogoutModal}>
          {t('myAccount.logout')}
        </ProfileActionItem>
      </StyledList>
    </>
  )
}
